module.exports = __webpack_public_path__ + "static/4-Jar with lid front-c80f53d5cec4019a91f4d1631451e22e.jpg";